import { Routes } from '@angular/router';
import { MyMachinesOverviewComponent } from '@app/pages/mymachines-overview/mymachines-overview.component';
import { MachineDetailsComponent } from './components/machine-details/machine-details.component';
import { LocaleGuard } from './guards';
import { CountrySelectionComponent } from './pages/country-selector/country-selection.component';
import { MachinesearchComponent } from './pages/machinesearch/machinesearch.component';
import { QrscannerComponent } from './components/poetpro/qrscanner/qrscanner.component';
import { MachinepageComponent } from './components/poetpro/machinepage/machinepage.component';
import { HighlightsAndDataComponent } from './components/poetpro/highlights-and-data/highlights-and-data.component';
import { MedienComponent } from './components/poetpro/medien/medien.component';
import { ZmediasComponent } from './components/poetpro/zmedias/zmedias.component';
import { FitmentsComponent } from './components/poetpro/fitments/fitments.component';
import { LauncherComponent } from '@app/pages/launcher/launcher.component';
import { ProfileOverviewComponent } from '@app/pages/profile-overview/profile-overview.component';
import { SupportComponent } from './pages/support/support.component';
import { FaqComponent } from './pages/faq/faq.component';
import { HaytoolAssistComponent } from './components/haytool-assist/haytool-assist.component';
import { TramlineAssistComponent } from './components/tramline-assist/tramline-assist.component';
import { RowCropAssistComponent } from './components/row-crop-assist/row-crop-assist.component';
import { LoginCallbackComponent } from './pages/login-callback/login-callback.component';
import { IdpLoginRedirectComponent } from './pages/idp-login/idp-login.component';
import { authGuardFn } from '@auth0/auth0-angular';
import { adminGuard } from './guards/admin.guard';

export const appRoutes: Routes = [
    { path: '', component: LauncherComponent, canActivate: [LocaleGuard] },
    { path: 'logout', component: LauncherComponent },
    { path: 'myMachines', component: MyMachinesOverviewComponent },
    { path: 'machine-details/:machinekey', component: MachineDetailsComponent, canActivate: [authGuardFn] },
    { path: 'login', component: IdpLoginRedirectComponent },
    { path: 'register', component: IdpLoginRedirectComponent, data: { screenHint: 'signup' } },
    { path: 'profile-overview', component: ProfileOverviewComponent, canActivate: [authGuardFn] },
    { path: 'home', component: LauncherComponent },
    { path: 'contact', component: SupportComponent },
    { path: 'locale', component: CountrySelectionComponent },
    {
        path: 'machinesearch',
        component: MachinesearchComponent,
        // pathMatch: 'full',
        children: [
            { path: 'qrscan', component: QrscannerComponent },
            { path: 'productrange', redirectTo: '/products' },
            { path: 'productrange/:find', redirectTo: '/products/:find' },
        ],
    },
    {path: 'products', loadChildren: () => import('./pages/product-range/product-range.routes').then(m => m.productRangeRoutes)},
    { path: 'machine', redirectTo: 'machinesearch' },
    {
        path: 'machine/:machinekey',
        component: MachinepageComponent,
        children: [
            { path: 'technicaldata', component: HighlightsAndDataComponent },
            { path: 'highlights', component: HighlightsAndDataComponent },
            { path: 'videos', component: MedienComponent },
            { path: 'images', component: MedienComponent },
            { path: 'operationmanual', component: ZmediasComponent },
            { path: 'lubricationplan', component: ZmediasComponent },
            { path: 'brochures', component: ZmediasComponent },
            { path: 'spareparts', component: ZmediasComponent },
            { path: 'technicalservice', component: ZmediasComponent },
            { path: 'assemblinginstructure', component: ZmediasComponent },
            { path: 'retrofitmanual', component: ZmediasComponent },
            { path: 'sparepartlists', component: ZmediasComponent },
            { path: 'lubricationplans', component: ZmediasComponent },
            { path: 'fitments', component: FitmentsComponent }
        ],
        canActivate: [LocaleGuard]
    },
    { path: 'faqs', component: FaqComponent },
    { path: 'haytool-assist', component: HaytoolAssistComponent, canActivate: [LocaleGuard] },
    { path: 'tramline-assist', component: TramlineAssistComponent, canActivate: [LocaleGuard] },
    { path: 'row-crop-assist', component: RowCropAssistComponent, canActivate: [LocaleGuard] },
    { path: 'machine-advisor', loadComponent: () => import('./pages/machine-advisor/machine-advisor.component').then(m => m.MachineAdvisorComponent) },
    { path: 'configurator', loadChildren: () => import('./pages/configurator/configurator.routes').then(m => m.configuratorRoutes) },
    {
        path: 'country-restricted',
        loadComponent: () => import('./pages/configurator/country-restricted/country-restricted.component').then(m => m.CountryRestrictedComponent),
    },
    {
        path: 'admin',
        canActivate: [authGuardFn, adminGuard],
        loadChildren: () => import('./pages/admin/admin.routes').then(m => m.adminRoutes)
    },
    { path: 'auth/callback', component: LoginCallbackComponent },
    {
        path: 'serviceinfo',
        loadChildren: () =>
            import('./pages/serviceinfo/serviceinfo.routes').then(m => m.serviceinfoRoutes)
    },
    {
        path: '404',
        loadComponent: () =>
            import('./pages/not-found/not-found.page').then(m => m.NotFoundPage)
    },
    // fallback-route
    { path: '**', redirectTo: 'home' }
];
